"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import SectionTitle from "@/components/common/section-title";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

              <EspaceProTitleCard title={"Le Guide du Partenaire"}
                                  middleBreadcrumbs={[{title: "Devenir Partenaire", link: "/espace-pro/devenir-partenaire"}]}
                                  description={"Participer à la création d’une industrie touristique durable."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <SectionTitle title={"Nos supports de communication"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <p className={"text-normal text-justify mt-4"}>
                  Nous vous proposons d’être annonceur dans nos différents supports de communication (magasine, guide de voyage, carte à l’embarquement, gadget, etc.) mais également de créer votre carte commerciale.
<br/>
<br/>
                  Notre équipe vous accompagne sur le choix des supports adaptés à votre cible clientèle mais également à votre budget. Ensemble, trouvons le mode de communication adapté au rayonnement de votre structure.
              </p>

              <SectionTitle title={"Nous confier votre billetterie"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  COTE D’IVOIRE TOURISME acteur majeur du tourisme, de la promotion de la culture et de l’évènementiel, propose des services certes aux visiteurs mais également aux socio-professionnels organisateurs d’évènements.
<br/>
<br/>
                  Nous travaillons à permettre au plus grand nombre d’accéder à la meilleure offre événementielle du moment. Nous vous offrons la possibilité d’optimiser les circuits de commercialisation et de promotion de la billetterie.
<br/>
<br/>
                  <strong>Pour vous accompagner dans la réussite de votre évènement, spectacle, visite organisées attractions :</strong>
<br/>
<br/>
                  <strong>La commercialisation de votre billetterie avec un service clé en main :</strong>
                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1">Une billetterie spécifique pour chacun de vos
                          évènements et une commission est reversée à l’Office
                      </li>
                      <li className="li1">L’Office envoie un état des lieux des ventes
                          régulièrement à compter de la mise en marché
                      </li>
                      <li className="li1">Le produit des ventes est restitué</li>
                  </ul>

                  <strong>La promotion de vos évènements sur nos supports de communication :</strong>

                  <ul className="list-disc pl-4 mt-4">
                      <li className="li1"><span className={"font-black"}>Sur notre site internet</span>
                      </li>
                      <li className="li1">Avec une fiche dédiée représentant votre
                          manifestation (visuel, information pratiques) dans la rubrique agenda des manifestations
                      </li>
                      <li className="li1">Promotion de la manifestation</li>
                      <li className="li1"><span className={"font-black"}>Au siège de l’Office et dans les bureaux d’information touristique flyers, vente au comptoir, diffusion de votre évènement sur nos écrans situe dans les espaces d’accueil public</span>
                      </li>
                  </ul>
              </div>

              <SectionTitle title={"Côte d’Ivoire Tourisme apporteur d’affaires"} className={"mt-8"} variant="playfairDisplay" size="small" />
              <SectionTitle title={"Le réseau CIT"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Vous pouvez rejoindre notre réseau de socio-professionnels afin de participer aux réunions d’échanges comme les <strong>« PETITS DEJEUNERS PARTENAIRES ».</strong> Ces rencontres nous permettent de vous informer de nos actions de promotion et surtout de vous y associer. Nous sommes un vivier d’informations touristiques et nous pouvons vous accompagner dans la recherche d’informations touristiques.
<br/>
<br/>
                  Dans notre industrie du tourisme, pour réussir il faut être performant. Une des clés de la performance est la maitrise de son territoire.
              </div>

              <SectionTitle title={"Accueil presse, eductours et accueil vip"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  <strong>L’accueil presse</strong> consiste à recevoir un ou des journalistes souhaitant faire un reportage sur la COTE D’IVOIRE. Nos services organisent, en collaboration avec ses partenaires, le programme thématique sur mesure correspondant à la demande des journalistes. De ces voyages de presse en résulte une mise en avant de la destination et de son offre touristique.
<br/>
<br/>
                  <strong>L’Eductour</strong> est l’organisation d’un programme de découverte sur une thématique destinée aux professionnels du tourisme (Tour Operator, Agence de Voyage) afin de les convaincre de positionner notre destination dans leurs guides.
                  <br/>
                  <br/>
                  <strong>L’Accueil VIP</strong> est destiné à recevoir une personnalité. Son séjour est organisé de telle sorte que la personnalité véhicule l’image de la COTE D’IVOIRE dans son environnement médiatique.
                  <br/>
                  <br/>
                  Pour ces différentes actions, COTE D’IVOIRE TOURISME mettra en avant ses partenaires. Ils seront contactés en fonction de la thématique du séjour. C’est l’Office qui prend en charge les dépenses liées à ces évènements. Aussi, les partenaires proposent à l’Office des tarifs réduits.
                  <br/>
                  <br/>
                  Les partenaires participent ainsi à une dynamique dans la promotion de la destination.
              </div>


             <SectionTitle title={"Notre club e-tourisme"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  L’e-tourisme est la traduction des évolutions de l’industrie du tourisme. De la préparation des vacances à son retour à la maison, les outils (ordinateurs, smartphones et tablettes) ne sont jamais loin. Le numérique fait partie de nos vies.
<br/>
<br/>
                  Les touristes sont devenus des experts pour comparer les bons plans, pour organiser leurs séjours mais aussi pour partager leurs expériences. Les comportements des voyageurs ainsi que leurs besoins sont en constante évolution.
<br/>
<br/>
                  Le numérique n’est plus une option mais une nécessité. Nous vous accompagnons à identifier, maitriser et exploiter les outils numériques pour votre structure.

              </div>

             <SectionTitle title={"Nos accompagnements personnalisés"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                 Un audit de votre communication sera fait pour établir cet accompagnement personnalisé. Cela nous permettra de mieux cerner les outils numériques utilisés ou pas par votre structure et ainsi vous conseiller sur des orientations possibles.
<br/>
<br/>
                  Nous construisons ensemble cet atelier numérique personnalisé.
              </div>

             <SectionTitle title={"Chambres d’hôtes référence CIT"} className={"mt-8"} variant="playfairDisplay" size="small" />

              <div className={"text-normal text-justify mt-4"}>
                  Il n’existe pas en Côte d’Ivoire de classement mis en place par l’Etat pour les chambres d’hôtes. L’objectif du dispositif Chambre d’Hôtes Référence CIT est de contribuer au développement de la qualification des hébergements touristiques et d’apporter la possibilité de garantir à leur clientèle une certaine qualité dans leurs prestations. Tout ceci afin de concourir à un accueil de qualité sur notre destination quelque soit le type d’hébergement.
              </div>

          </SectionPage>

          </div>
  );
}
